module.exports = __webpack_public_path__ + "img/stores.48b19062.svg";